module.exports = __webpack_public_path__ + "img/game_dis.60ed4f41.png";